import React, { useEffect, useState } from "react";
import { Modal } from "rsuite";
import api from "../../../../services/axios";
import { toast } from "react-toastify";
import { ptBR } from "date-fns/locale";

import DatePicker from "react-datepicker";
import { MdCalendarMonth, MdEdit, MdLock, MdGroups, MdErrorOutline, MdOpenInNew } from "react-icons/md";
import Toggle from "../../../../components/toggle";
import { FormaLogin } from "../../../../interfaces/Identidade";
import DominiosField from "./DominiosField";
import TenantEntraField, { tenantEntraParaEnvio, tenantEntraValido } from "./TenantEntraField";
import PortalUsersSection from "./PortalUsersSection";
import { SIIMP_NATUREZAS, SIIMP_SERVICOS } from "./siimpFiscal";

type ClientModel = {
  id: number;
  legalName: string;
  tradeName: string;
  document: string;
  email: string;
  phone: string;
  entryDate: Date;
  flActive: boolean;
  jiraProjectId: number;
  billingChannels?: number[];
  receivesHoursReport: boolean;
  reportFrequency: number | null;
  reportDayOfWeek: number | null;
  reportHour: number | null;
  emailNF: string | null;
  emailBilling: string | null;
  address: string | null;
  municipalRegistration: string | null;
  paymentTermDays: number | null;
  siimpNfseServicoId: number | null;
  siimpNaturezaFiscal: number | null;
  billingDay: number | null;
  paymentMethod: number | null;
  formaLogin: FormaLogin;
  dominios: string[];
  entraTenantId: string | null;
};

const WEEK_DAYS = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
const PAYMENT_METHODS = [
  { value: 1, label: "Boleto" },
  { value: 2, label: "Pix" },
  { value: 3, label: "Transferência / TED" },
  { value: 4, label: "Cartão de crédito" },
  { value: 5, label: "Outro" },
];

const labelCls = "text-sm font-semibold text-gray-700 dark:text-gray-300";

const ModalViewDetailClient: React.FC<any> = ({
  openClientDetailModal,
  setOpenClientDetailModal,
  details,
  updateState,
  jiraProjectList,
}) => {
  const [legalName, setLegalName] = useState<string>("");
  const [tradeName, setTradeName] = useState<string>("");
  const [document, setDocument] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [entryDate, setEntryDate] = useState<any>(null);
  const [status, setStatus] = useState<boolean>(false);
  const [jiraProject, setJiraProject] = useState("");
  const [billingChannels, setBillingChannels] = useState<number[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [receivesHoursReport, setReceivesHoursReport] = useState<boolean>(false);
  const [reportFrequency, setReportFrequency] = useState<number>(1);
  const [reportDayOfWeek, setReportDayOfWeek] = useState<number>(1);
  const [reportHour, setReportHour] = useState<number>(8);

  // Projetos do cliente (somente leitura)
  const [clientProjects, setClientProjects] = useState<any[]>([]);
  const [projectsLoading, setProjectsLoading] = useState(false);

  // Contratos do cliente (microserviço contract-weaver; somente leitura)
  const [clientContracts, setClientContracts] = useState<any[]>([]);
  const [contractsLoading, setContractsLoading] = useState(false);

  // Dados fiscais / NF
  const [emailNF, setEmailNF] = useState<string>("");
  const [emailBilling, setEmailBilling] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [municipalRegistration, setMunicipalRegistration] = useState<string>("");
  const [paymentTermDays, setPaymentTermDays] = useState<string>("");
  const [siimpNfseServicoId, setSiimpNfseServicoId] = useState<string>("");
  const [siimpNaturezaFiscal, setSiimpNaturezaFiscal] = useState<string>("");
  const [billingDay, setBillingDay] = useState<string>("");
  const [paymentMethod, setPaymentMethod] = useState<string>("");

  // Identidade
  const [formaLogin, setFormaLogin] = useState<FormaLogin>(0);
  const [dominios, setDominios] = useState<string[]>([]);
  const [dominiosError, setDominiosError] = useState("");
  const [entraTenantId, setEntraTenantId] = useState("");

  useEffect(() => {
    setIsEditing(false);
    setErrorMessage("");
    setJiraProject(details?.jiraProjectId != null ? String(details.jiraProjectId) : "");
    setLegalName(details?.legalName ?? "");
    setTradeName(details?.tradeName ?? "");
    setDocument(details?.document ?? "");
    setEmail(details?.email ?? "");
    setPhone(details?.phone ?? "");
    setEntryDate(details?.entryDate != null ? new Date(details.entryDate) : null);
    setStatus(details?.flActive ?? false);
    setBillingChannels(details?.billingChannels ?? []);
    setReceivesHoursReport(details?.receivesHoursReport ?? false);
    setReportFrequency(details?.reportFrequency ?? 1);
    setReportDayOfWeek(details?.reportDayOfWeek ?? 1);
    setReportHour(details?.reportHour ?? 8);
    setEmailNF(details?.emailNF ?? "");
    setEmailBilling(details?.emailBilling ?? "");
    setAddress(details?.address ?? "");
    setMunicipalRegistration(details?.municipalRegistration ?? "");
    setPaymentTermDays(details?.paymentTermDays != null ? String(details.paymentTermDays) : "");
    setSiimpNfseServicoId(details?.siimpNfseServicoId != null ? String(details.siimpNfseServicoId) : "");
    setSiimpNaturezaFiscal(details?.siimpNaturezaFiscal != null ? String(details.siimpNaturezaFiscal) : "");
    setBillingDay(details?.billingDay != null ? String(details.billingDay) : "");
    setPaymentMethod(details?.paymentMethod != null ? String(details.paymentMethod) : "");
    setFormaLogin(details?.formaLogin === 1 ? 1 : 0);
    setDominios(details?.dominios ?? []);
    setDominiosError("");
    setEntraTenantId(details?.entraTenantId ?? "");

    // Carrega os projetos do cliente (somente leitura) ao abrir o modal.
    if (openClientDetailModal && details?.id) {
      setProjectsLoading(true);
      setClientProjects([]);
      api
        .get(`/ClientProject/client/${details.id}`)
        .then((r) => setClientProjects(Array.isArray(r.data) ? r.data : []))
        .catch((e) => console.error("Erro ao carregar projetos do cliente", e))
        .finally(() => setProjectsLoading(false));

      setContractsLoading(true);
      setClientContracts([]);
      api
        .get(`/Client/Clients/${details.id}/contracts`)
        .then((r) => setClientContracts(Array.isArray(r.data) ? r.data : []))
        .catch((e) => console.error("Erro ao carregar contratos do cliente", e))
        .finally(() => setContractsLoading(false));

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openClientDetailModal]);

  // Deep-link para o microserviço contract-weaver, filtrado pelo cliente.
  const contractWeaverUrl = process.env.REACT_APP_CONTRACT_WEAVER_URL;
  const openContractWeaver = () => {
    if (!contractWeaverUrl) {
      toast.info("Configure REACT_APP_CONTRACT_WEAVER_URL para abrir o Contract Weaver.");
      return;
    }
    const base = contractWeaverUrl.replace(/\/$/, "");
    window.open(`${base}/?ninaClientId=${details?.id ?? ""}`, "_blank", "noopener");
  };

  const handleClose = () => {
    setOpenClientDetailModal(false);
  };

  const handleUpdateClient = async () => {
    const clientData: ClientModel = {
      id: details.id,
      legalName,
      tradeName,
      document,
      email,
      phone,
      entryDate,
      flActive: status,
      jiraProjectId: Number(jiraProject),
      billingChannels,
      receivesHoursReport,
      reportFrequency: receivesHoursReport ? reportFrequency : null,
      reportDayOfWeek: receivesHoursReport ? reportDayOfWeek : null,
      reportHour: receivesHoursReport ? reportHour : null,
      emailNF: emailNF || null,
      emailBilling: emailBilling || null,
      address: address || null,
      municipalRegistration: municipalRegistration || null,
      paymentTermDays: paymentTermDays ? Number(paymentTermDays) : null,
      siimpNfseServicoId: siimpNfseServicoId ? Number(siimpNfseServicoId) : null,
      siimpNaturezaFiscal: siimpNaturezaFiscal ? Number(siimpNaturezaFiscal) : null,
      billingDay: billingDay ? Number(billingDay) : null,
      paymentMethod: paymentMethod ? Number(paymentMethod) : null,
      formaLogin,
      dominios,
      entraTenantId: tenantEntraParaEnvio(entraTenantId),
    };
    await updateClient(clientData);
  };

  const handleDatePicker = (date: any) => {
    setEntryDate(new Date(date));
  };

  async function updateClient(Client: ClientModel) {
    try {
      setLoading(true);
      setDominiosError("");
      const response = await api.put("/Client/Clients", Client);

      if (response.status !== 200) {
        const msg = response.data.message || JSON.stringify(response.data);
        toast.error(msg, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.success("Client updated successfully", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        updateState();
        handleClose();
      }
    } catch (error: any) {
      // 409 = domínio já usado por outro cliente: mostra o texto do backend embaixo do campo.
      if (error?.response?.status === 409) {
        const data = error.response.data;
        setDominiosError(
          (typeof data === "string" ? data : data?.message || data?.title) ||
            "Um dos domínios já pertence a outro cliente."
        );
        return;
      }
      console.error("Network error updating client:", error);
      // 400 do backend (ex.: tenant que não é GUID) traz a mensagem certa; sem ela, vale a genérica.
      const msg400 = error?.response?.status === 400 ? error.response.data?.message : null;
      const mensagem = typeof msg400 === "string" && msg400 ? msg400 : "Network error updating client";
      setErrorMessage(mensagem);
      toast.error(mensagem, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const inputClass = (editable: boolean) =>
    `w-full rounded-xl border px-3 py-2.5 text-sm transition-all focus:outline-none ${
      editable
        ? "border-gray-200 bg-white text-gray-800 focus:border-dv-blue-500 focus:ring-2 focus:ring-dv-blue-500/20 dark:border-white/10 dark:bg-navy-900 dark:text-white"
        : "cursor-not-allowed border-gray-100 bg-gray-50 text-gray-700 dark:border-gray-700 dark:bg-navy-900/50 dark:text-gray-300"
    }`;

  return (
    <Modal
      backdrop="static"
      open={openClientDetailModal}
      size="lg"
      onClose={handleClose}
    >
      <Modal.Header className="border-b border-gray-100 pb-3 dark:border-gray-700">
        <Modal.Title>
          <div className="flex items-center justify-between pr-6">
            <div className="flex items-center gap-3">
              <div className="dv-aura flex h-11 w-11 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow">
                <MdGroups className="h-6 w-6" aria-hidden="true" />
              </div>
              <div>
                <h2 className="text-base font-bold text-navy-700 dark:text-white">
                  Detalhes do cliente
                </h2>
                <p className="text-xs font-normal text-gray-700 dark:text-gray-300">
                  {details?.legalName || "—"}
                </p>
              </div>
            </div>
            <button
              type="button"
              aria-label={isEditing ? "Bloquear edição" : "Editar cliente"}
              onClick={() => setIsEditing((prev) => !prev)}
              className={`flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-xs font-semibold transition-all ${
                isEditing
                  ? "bg-amber-100 text-amber-700 hover:bg-amber-200 dark:bg-amber-900/40 dark:text-amber-300"
                  : "bg-dv-blue-500/10 text-dv-blue-600 hover:bg-dv-blue-500/20 dark:text-dv-cyan-300"
              }`}
            >
              {isEditing ? (
                <>
                  <MdLock className="h-3.5 w-3.5" aria-hidden="true" />
                  Bloquear
                </>
              ) : (
                <>
                  <MdEdit className="h-3.5 w-3.5" aria-hidden="true" />
                  Editar
                </>
              )}
            </button>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="px-1 py-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {/* Legal Name */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-legalName" className={labelCls}>
                Razão Social <span className="text-red-500">*</span>
              </label>
              <input
                id="view-client-legalName"
                value={legalName}
                onChange={(e) => setLegalName(e.target.value)}
                disabled={!isEditing}
                className={inputClass(isEditing)}
                placeholder="ex.: Acme Corporation Ltda."
              />
            </div>

            {/* Trade Name */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-tradeName" className={labelCls}>
                Nome Fantasia <span className="text-red-500">*</span>
              </label>
              <input
                id="view-client-tradeName"
                value={tradeName}
                onChange={(e) => setTradeName(e.target.value)}
                disabled={!isEditing}
                className={inputClass(isEditing)}
                placeholder="ex.: Acme"
              />
            </div>

            {/* CNPJ */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-document" className={labelCls}>
                CNPJ <span className="text-red-500">*</span>
              </label>
              <input
                id="view-client-document"
                value={document}
                onChange={(e) => setDocument(e.target.value)}
                disabled={!isEditing}
                className={`${inputClass(isEditing)} tabular-nums`}
                placeholder="00.000.000/0000-00"
              />
            </div>

            {/* Email */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-email" className={labelCls}>
                E-mail
              </label>
              <input
                id="view-client-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!isEditing}
                className={inputClass(isEditing)}
                placeholder="contato@empresa.com"
              />
            </div>

            {/* WhatsApp */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-phone" className={labelCls}>
                WhatsApp
              </label>
              <input
                id="view-client-phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={!isEditing}
                className={inputClass(isEditing)}
                placeholder="+55 (00) 00000-0000"
              />
            </div>

            {/* Contract Date */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-entryDate" className={labelCls}>
                Data do contrato <span className="text-red-500">*</span>
              </label>
              <DatePicker
                id="view-client-entryDate"
                showIcon
                selected={entryDate}
                locale={ptBR}
                icon={<MdCalendarMonth className="mt-1.5 text-base" aria-hidden="true" />}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => handleDatePicker(date)}
                disabled={!isEditing}
                placeholderText="Selecione uma data"
                className={`h-[42px] w-full rounded-xl border px-3 text-sm transition-all focus:outline-none ${
                  isEditing
                    ? "border-gray-200 bg-white text-gray-800 focus:border-dv-blue-500 focus:ring-2 focus:ring-dv-blue-500/20 dark:border-white/10 dark:bg-navy-900 dark:text-white"
                    : "cursor-not-allowed border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-navy-900/50"
                }`}
              />
            </div>

            {/* Jira Project */}
            <div className="flex flex-col gap-1.5">
              <label htmlFor="view-client-jiraProject" className={labelCls}>
                Projeto Jira
              </label>
              <select
                id="view-client-jiraProject"
                value={jiraProject}
                onChange={(e) => setJiraProject(e.target.value)}
                disabled={!isEditing}
                className={inputClass(isEditing)}
              >
                <option value="">Selecione um projeto Jira</option>
                {jiraProjectList?.map((project: any) => (
                  <option key={project.id} value={project.id}>
                    {project.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Status */}
            <div className="flex flex-col gap-1.5">
              <label className={labelCls}>Status</label>
              <div className="flex h-[42px] items-center gap-2">
                <Toggle
                  checked={status}
                  onClick={() => isEditing && setStatus(!status)}
                />
                <span
                  className={`text-sm font-semibold ${
                    status
                      ? "text-emerald-600 dark:text-emerald-400"
                      : "text-gray-700 dark:text-gray-300"
                  }`}
                >
                  {status ? "Ativo" : "Inativo"}
                </span>
              </div>
            </div>
          </div>

          {/* Report de horas */}
          <div className="mt-5 rounded-2xl border border-gray-200 p-4 dark:border-gray-600">
            <div className="flex items-center justify-between gap-4">
              <div>
                <span className="text-sm font-semibold text-navy-700 dark:text-white">
                  Recebe report de horas
                </span>
                <span className="block text-xs text-gray-700 dark:text-gray-300">
                  Envio automático do resumo de horas por e-mail
                </span>
              </div>
              <button
                type="button"
                aria-label="Alternar recebimento de report de horas"
                aria-pressed={receivesHoursReport}
                onClick={() => isEditing && setReceivesHoursReport((v) => !v)}
                disabled={!isEditing}
                className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ${
                  receivesHoursReport ? "bg-dv-blue-500" : "bg-gray-300 dark:bg-gray-600"
                } ${!isEditing ? "cursor-not-allowed opacity-60" : ""}`}
              >
                <span
                  className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ${
                    receivesHoursReport ? "translate-x-5" : ""
                  }`}
                />
              </button>
            </div>

            {receivesHoursReport && (
              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="view-client-frequency" className={labelCls}>
                    Frequência
                  </label>
                  <select
                    id="view-client-frequency"
                    value={reportFrequency}
                    onChange={(e) => setReportFrequency(Number(e.target.value))}
                    disabled={!isEditing}
                    className={inputClass(isEditing)}
                  >
                    <option value={1}>Semanal</option>
                    <option value={2}>Quinzenal</option>
                    <option value={3}>Mensal</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="view-client-dayOfWeek" className={labelCls}>
                    Dia da semana
                  </label>
                  <select
                    id="view-client-dayOfWeek"
                    value={reportDayOfWeek}
                    onChange={(e) => setReportDayOfWeek(Number(e.target.value))}
                    disabled={!isEditing}
                    className={inputClass(isEditing)}
                  >
                    {WEEK_DAYS.map((d, i) => (
                      <option key={i} value={i}>{d}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="view-client-hour" className={labelCls}>
                    Horário
                  </label>
                  <select
                    id="view-client-hour"
                    value={reportHour}
                    onChange={(e) => setReportHour(Number(e.target.value))}
                    disabled={!isEditing}
                    className={inputClass(isEditing)}
                  >
                    {Array.from({ length: 24 }, (_, h) => (
                      <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          {/* Dados fiscais / NF */}
          <div className="mt-5 rounded-2xl border border-gray-200 p-4 dark:border-gray-600">
            <span className="text-sm font-semibold text-navy-700 dark:text-white">
              Dados fiscais / NF
            </span>
            <span className="mb-3 block text-xs text-gray-700 dark:text-gray-300">
              Informações usadas no processo de emissão de nota fiscal e cobrança
            </span>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-emailNF" className={labelCls}>E-mail para NF</label>
                <input id="view-client-emailNF" type="email" value={emailNF} onChange={(e) => setEmailNF(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="nf@empresa.com" />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-emailBilling" className={labelCls}>E-mail para cobrança</label>
                <input id="view-client-emailBilling" type="email" value={emailBilling} onChange={(e) => setEmailBilling(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="financeiro@empresa.com" />
              </div>
              <div className="flex flex-col gap-1.5 sm:col-span-2">
                <label htmlFor="view-client-address" className={labelCls}>Endereço completo</label>
                <input id="view-client-address" value={address} onChange={(e) => setAddress(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="Rua, nº, bairro, cidade/UF, CEP" />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-municipal" className={labelCls}>Inscrição municipal</label>
                <input id="view-client-municipal" value={municipalRegistration} onChange={(e) => setMunicipalRegistration(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="Opcional" />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-paymentMethod" className={labelCls}>Forma de pagamento</label>
                <select id="view-client-paymentMethod" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)}>
                  <option value="">Selecione…</option>
                  {PAYMENT_METHODS.map((p) => (
                    <option key={p.value} value={p.value}>{p.label}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-paymentTerm" className={labelCls}>Prazo de pagamento (dias)</label>
                <input id="view-client-paymentTerm" type="number" min={0} value={paymentTermDays} onChange={(e) => setPaymentTermDays(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="ex.: 30" />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-billingDay" className={labelCls}>Dia de cobrança</label>
                <input id="view-client-billingDay" type="number" min={1} max={31} value={billingDay} onChange={(e) => setBillingDay(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)} placeholder="1–31" />
              </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="view-client-siimpServico" className={labelCls}>Serviço da NFS-e (SIIMP)</label>
                  <select id="view-client-siimpServico" value={siimpNfseServicoId} onChange={(e) => setSiimpNfseServicoId(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)}>
                    <option value="">Padrão</option>
                    {SIIMP_SERVICOS.map((s) => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="view-client-siimpNatureza" className={labelCls}>Natureza fiscal da NFS-e</label>
                  <select id="view-client-siimpNatureza" value={siimpNaturezaFiscal} onChange={(e) => setSiimpNaturezaFiscal(e.target.value)} disabled={!isEditing} className={inputClass(isEditing)}>
                    <option value="">Padrão</option>
                    {SIIMP_NATUREZAS.map((n) => (
                      <option key={n.value} value={n.value}>{n.label}</option>
                    ))}
                  </select>
                </div>
            </div>
          </div>

          {/* Projetos do cliente */}
          <div className="mt-5 rounded-2xl border border-gray-200 p-4 dark:border-gray-600">
            <span className="text-sm font-semibold text-navy-700 dark:text-white">
              Projetos do cliente
            </span>
            <span className="mb-3 block text-xs text-gray-700 dark:text-gray-300">
              Projetos vinculados a este cliente
            </span>
            {projectsLoading ? (
              <p className="text-sm text-gray-700 dark:text-gray-300">Carregando…</p>
            ) : clientProjects.length === 0 ? (
              <p className="text-sm text-gray-700 dark:text-gray-300">Nenhum projeto vinculado.</p>
            ) : (
              <ul className="flex flex-col gap-2">
                {clientProjects.map((p) => (
                  <li
                    key={p.id}
                    className="flex items-center justify-between rounded-xl border border-gray-100 px-3 py-2 text-sm dark:border-gray-700"
                  >
                    <span className="font-medium text-navy-700 dark:text-white">
                      {p.nmProject ?? `#${p.projectId}`}
                    </span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                        p.flActive
                          ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300"
                          : "bg-gray-100 text-gray-600 dark:bg-navy-700 dark:text-gray-300"
                      }`}
                    >
                      {p.flActive ? "Ativo" : "Inativo"}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Contratos (microserviço contract-weaver) */}
          <div className="mt-5 rounded-2xl border border-gray-200 p-4 dark:border-gray-600">
            <div className="mb-3 flex items-center justify-between gap-3">
              <div>
                <span className="text-sm font-semibold text-navy-700 dark:text-white">
                  Contratos
                </span>
                <span className="block text-xs text-gray-700 dark:text-gray-300">
                  Contratos vinculados a este cliente (Contract Weaver)
                </span>
              </div>
              <button
                type="button"
                onClick={openContractWeaver}
                className="flex items-center gap-1.5 rounded-xl border border-dv-blue-200 px-3 py-1.5 text-xs font-semibold text-dv-blue-600 transition-all hover:bg-dv-blue-50 dark:border-dv-blue-500/30 dark:text-dv-cyan-300 dark:hover:bg-white/5"
              >
                <MdOpenInNew className="h-3.5 w-3.5" aria-hidden="true" />
                Gerenciar no Contract Weaver
              </button>
            </div>
            {contractsLoading ? (
              <p className="text-sm text-gray-700 dark:text-gray-300">Carregando…</p>
            ) : clientContracts.length === 0 ? (
              <p className="text-sm text-gray-700 dark:text-gray-300">Nenhum contrato vinculado.</p>
            ) : (
              <ul className="flex flex-col gap-2">
                {clientContracts.map((c) => (
                  <li
                    key={c.id}
                    className="flex items-center justify-between gap-3 rounded-xl border border-gray-100 px-3 py-2 text-sm dark:border-gray-700"
                  >
                    <div className="min-w-0">
                      <p className="truncate font-medium text-navy-700 dark:text-white">
                        {c.razaoSocial || c.modelo || "Contrato"}
                      </p>
                      <p className="truncate text-[11px] text-gray-700 dark:text-gray-300">
                        {c.modelo ? `${c.modelo} · ` : ""}
                        {c.valorMensal != null
                          ? `R$ ${Number(c.valorMensal).toLocaleString("pt-BR")}/mês`
                          : ""}
                        {c.createdAt ? ` · ${new Date(c.createdAt).toLocaleDateString("pt-BR")}` : ""}
                      </p>
                    </div>
                    <span className="shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-600 dark:bg-navy-700 dark:text-gray-300">
                      {c.assinafyStatus || c.status || "—"}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Acesso ao portal: usuários, áreas liberadas e redefinição de senha */}
          <PortalUsersSection clientId={details?.id} open={openClientDetailModal} />

          {/* Identidade */}
          <div className="mt-5 rounded-2xl border border-gray-200 p-4 dark:border-gray-600">
            <span className="text-sm font-semibold text-navy-700 dark:text-white">Acesso ao portal</span>
            <span className="mb-3 block text-xs text-gray-700 dark:text-gray-300">
              Como as pessoas desta organização entram e quais domínios de e-mail são dela
            </span>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="flex flex-col gap-1.5">
                <label htmlFor="view-client-formaLogin" className={labelCls}>Forma de login</label>
                <select id="view-client-formaLogin" value={formaLogin} onChange={(e) => setFormaLogin(Number(e.target.value) as FormaLogin)} disabled={!isEditing} className={inputClass(isEditing)}>
                  <option value={0}>Senha</option>
                  <option value={1}>Conta Microsoft</option>
                </select>
              </div>
              <DominiosField id="view-client-dominios" value={dominios} onChange={setDominios} disabled={!isEditing} error={dominiosError} labelCls={labelCls} inputCls={inputClass(isEditing)} />
              <TenantEntraField id="view-client-entraTenantId" value={entraTenantId} onChange={setEntraTenantId} disabled={!isEditing} labelCls={labelCls} inputCls={inputClass(isEditing)} />
            </div>
          </div>

          {errorMessage && (
            <div className="mt-4 flex items-center gap-2 rounded-xl bg-red-50 px-3 py-2 text-sm text-red-600 dark:bg-red-900/20 dark:text-red-300">
              <MdErrorOutline className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
              {errorMessage}
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="border-t border-gray-100 pt-3 dark:border-gray-700">
        <div className="flex gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] dark:border-gray-600 dark:text-gray-200 dark:hover:bg-navy-700"
          >
            Cancelar
          </button>
          {loading ? (
            <button
              type="button"
              className="flex flex-1 cursor-not-allowed items-center justify-center gap-2 rounded-xl bg-dv-gradient px-5 py-2.5 text-sm font-bold text-white opacity-60"
              disabled
            >
              <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              Processando…
            </button>
          ) : (
            <button
              type="submit"
              onClick={handleUpdateClient}
              disabled={
                !isEditing ||
                legalName.length < 5 ||
                document.length < 5 ||
                tradeName.length < 3 ||
                !tenantEntraValido(entraTenantId)
              }
              className="dv-sheen flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-dv-gradient px-5 py-2.5 text-sm font-bold text-white shadow-dv-glow transition-all active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50"
            >
              Salvar alterações
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalViewDetailClient;
